import React from 'react';
import useGoToPage from '../../../hooks/useGoToPage';
import pages from '../../../routes/pages';
import useStyle from './serviceMessages.style';
import { ButtonWithText } from '../../atoms/Buttons/ButtonWithText';

interface ServiceMessagesProps {
  text: string;
  status?: string | number;
  extra?: string;
}

export const ServiceMessages = ({
  text,
  status = 'oups...',
  extra
}: ServiceMessagesProps) => {
  const to = useGoToPage(pages.HOME_PAGE.path);
  const classes = useStyle();

  return (
    <div className={classes.root}>
      {status && <p className={classes.status}>{status}</p>}
      <p className={classes.text}>{text}</p>
      {extra && <p className={classes.extra}>{extra}</p>}
      <ButtonWithText content={"Revenir à l'accueil ?"} onClick={to} />
    </div>
  );
};
